import * as types from '../const/action.types';
import { loadCatalogs } from './api.catalog.actions';
import { pendingCommunications } from './communications.actions';

import { get, put } from '../api/_basic';

const validPeriod = 30;

export function loginUser(user, password) {
    return async function(dispatch) {
        return put(`${process.env.REACT_APP_API_USER}/${user}/validate`, { password: password })
            .then((response) => {
                if (response.error !== undefined) {
                    console.log(response);
                    throw Error(response.error);
                }
                return response;
            })
            .then(async (loginInfo) => {
                sessionStorage.setItem('token', 'Bearer ' + loginInfo.token);
                try {
                    const now = new Date();
                    dispatch(loadBasicInfo());
                    dispatch(loadInfo(user));
                    dispatch(pendingCommunications());
                    dispatch(
                        loginSuccess(
                            user,
                            'Bearer ' + loginInfo.token,
                            new Date(now.getTime() + validPeriod * 60000),
                        ),
                    );
                    dispatch(setTutorial(!loginInfo.ultimologin));
                } catch (error) {
                    throw error;
                }
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function changeActiveClient(client) {
    return async function(dispatch) {
        return put(`${process.env.REACT_APP_API_CLIENT}/${client}/seleccionar`)
            .then((response) => {
                if (response.error !== undefined) {
                    console.log(response);
                    throw Error(response.error);
                }
                return response;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function resetPassword(user) {
    return async function(dispatch) {
        return put(`${process.env.REACT_APP_API_USER}/${user}/resetpassword`, {})
            .then((response) => {
                if (response.error !== undefined) {
                    console.log(response);
                    throw Error(response.error);
                }
                return response.success;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function recoveryPassword(password, token) {
    return async function(dispatch) {
        return put(`${process.env.REACT_APP_API_USER}/doreset`, {
            password: password,
            token: token,
        })
            .then((response) => {
                if (response.error !== undefined) {
                    console.log(response);
                    throw Error(response.error);
                }
                return response.success;
            })
            .catch((error) => {
                console.log(error);
                throw error;
            });
    };
}

export function loadInfo(user) {
    return async function(dispatch) {
        dispatch(sessionUsersHasErrored(false, ''));
        dispatch(sessionUsersIsLoading(true));
        return get(`${process.env.REACT_APP_API_USER}/${user}`)
            .then((response) => {
                dispatch(sessionUsersIsLoading(false));
                if (response.error !== undefined) {
                    throw Error(response);
                }
                return response;
            })
            .then((item) => {
                dispatch(sessionUsersHasErrored(false, ''));
                dispatch(sessionUserSuccess(item));
            })
            .catch((error) => {
                dispatch(sessionUsersHasErrored(error.type ? error.type : true, error.message));
            });
    };
}

export function updateValidTime(time) {
    return {
        type: types.KEEP_SESSION,
        time,
    };
}

export function loginSuccess(user, token, valid) {
    return {
        type: types.LOG_IN_SUCCESS,
        user,
        token,
        valid,
    };
}

export function keepSession() {
    return async function(dispatch) {
        return put(`${process.env.REACT_APP_API_USER}/${sessionStorage.user}/ping`)
            .then((response) => {
                if (response.error !== undefined) {
                    throw Error(response.error);
                }
                const now = new Date();
                sessionStorage.setItem('valid', new Date(now.getTime() + validPeriod * 60000));
            })
            .catch((error) => {
                throw error;
            });
    };
}

export function logOutUser() {
    sessionStorage.setItem('user', undefined);
    sessionStorage.setItem('token', undefined);
    sessionStorage.setItem('valid', undefined);
    localStorage.clear();
    return { type: types.LOG_OUT };
}

function getNodeInfo(node, arr) {
    const tree = Object.keys(node).map(async (i) => {
        const info = arr.find((f) => f.id === parseInt(i.toString(), 10));
        return {
            collapsed: false,
            id: i,
            name: info.nombrecorto,
            path: info.nombre,
            children: node[i] !== true ? await getNodeInfo(node[i], arr) : [],
            leaf: node[i] === true,
        };
    });

    const result = Promise.all(tree).then((complete) => {
        return complete;
    });
    return result;
}

export function loadBasicInfo() {
    return async function(dispatch) {
        const data = await get(process.env.REACT_APP_API_SECURITY);
        const paths = data.jerarquias.map((m) => m.nombre);
        const locals = data.jerarquias.map((l) => {
            const elements = paths.find((f) => f.includes(l.nombre) && f !== l.nombre);
            return {
                id: l.id,
                name: l.nombrecorto,
                path: l.nombre,
                leaf: elements ? false : true,
            };
        });
        const users = data.usuarios.map((u) => {
            return {
                id: parseInt(u.id, 10),
                name: u.nombre,
                type: 'user',
            };
        });
        let roles = data.roles.map((u) => {
            return {
                id: parseInt(u.id, 10),
                name: u.nombre,
                type: 'rol',
            };
        });

        const ids = roles.map((id) => id.id);
        const aux = await get(`${process.env.REACT_APP_API_ROLES}`);
        roles = roles.concat(
            aux.reduce((arr, u) => {
                if (
                    ids.indexOf(parseInt(u.id, 10)) < 0 &&
                    arr.map((i) => i.id).indexOf(parseInt(u.id, 10)) < 0
                ) {
                    arr.push({
                        id: parseInt(u.id, 10),
                        name: u.nombre,
                        type: 'rol',
                    });
                }
                return arr;
            }, []),
        );

        const destinatarios = await get(`${process.env.REACT_APP_API_SSE_DESTINATION}`);
        const classes = await get(`${process.env.REACT_APP_API_DISPLAYCLASSES}`);
        const elements = await getNodeInfo(data.jerarquiasarbol, data.jerarquias);
        const total = Object.keys(data.rolesusuario).map(function(i) {
            return data.rolesusuario[i];
        });

        console.log('SECURITY', data, elements);

        if (total.indexOf('20') === -1) {
            let index = roles.map((r) => r.id).indexOf(20);
            if (index >= 0) roles.splice(index, 1);

            index = roles.map((r) => r.id).indexOf(65);
            if (index >= 0) roles.splice(index, 1);
        }

        const security = {
            hierarchies:
                elements.length === 1
                    ? elements[0]
                    : {
                          code: 0,
                          name: undefined,
                          children: elements,
                      },
            clients: data.clientes,
            locals: locals,
            users: users,
            roles: roles,
            classes: classes,
            destinatarios: []
                .concat(
                    destinatarios && destinatarios.usuarios
                        ? destinatarios.usuarios.map((u) => {
                              return {
                                  id: parseInt(u.id, 10),
                                  name: u.nombre,
                                  type: 'user',
                              };
                          })
                        : [],
                )
                .concat(
                    destinatarios && destinatarios.roles
                        ? destinatarios.roles.map((u) => {
                              return {
                                  id: parseInt(u.id, 10),
                                  name: u.nombre,
                                  type: 'rol',
                              };
                          })
                        : [],
                ),
            suggestions: users.concat(roles),
            localPermits: data.permisos,
            globalPermits: data.rolesglobales,
            nivelUsuario: data.nivelUsuario,
            totalPermits: total,
            licencias: data.licencias,
        };
        dispatch(loadCatalogs());
        dispatch(loadSecuritySucces(security));
        return security;
    };
}

export function loadSecuritySucces(data) {
    return {
        type: types.LOAD_BASIC_INFO_SECURITY,
        data,
    };
}

export function sessionUserSuccess(data) {
    return {
        type: types.LOAD_SESSION_USER_SUCCESS,
        data,
    };
}

export function sessionUsersHasErrored(bool, message) {
    return {
        type: types.SESSION_USER_HAS_ERROR,
        hasErrored: bool,
        error: message,
    };
}

export function sessionUsersIsLoading(bool) {
    return {
        type: types.SESSION_USER_IS_LOADING,
        isLoading: bool,
    };
}

export function setTutorial(bool) {
    return {
        type: types.TUTORIAL,
        show: bool,
    };
}



// WEBPACK FOOTER //
// ./src/actions/session.actions.js